// removed by extract-text-webpack-plugin
module.exports = {"img-loading":"img-loading"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/Loading/style.less
// module id = 427
// module chunks = 431